import PropTypes from 'prop-types'
import React from 'react'
import EditAddressForm from './EditAddressForm'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import { SubmissionError } from 'redux-form'
import { injectIntl } from 'react-intl'

export class EditAddress extends React.Component {
  static propTypes = {
    leftSidebar: PropTypes.object.isRequired,

    name: PropTypes.string.isRequired,
    validateAddress: PropTypes.bool,
    onEditAddress: PropTypes.func.isRequired,
    boardId: PropTypes.number,
    cardTemplateId: PropTypes.number,
  }

  cancelForm = () => {
    this.props.leftSidebar.pop()
  }

  handleFormSubmit = ({ cardTemplateId, validateAddress }) => {
    const {
      intl,
      name,
      onEditAddress
    } = this.props

    return onEditAddress({
      name,
      cardTemplateId: cardTemplateId === 'empty' ? null : Number(cardTemplateId),
      validateAddress: validateAddress,
    }).then(() => {
      this.cancelForm()
    }).catch(error => {
      if (error.code === 300) {
        throw new SubmissionError({
          cardTemplateId: true,
          _error: intl.formatMessage({ id: 'INCOMING_EMAILS_DUPLICATE' }),
        })
      } else {
        throw error
      }
    })
  }

  render () {
    const {
      validateAddress,
      boardId,
      cardTemplateId,
    } = this.props

    return (
      <EditAddressForm
        boardId={boardId}
        initialValues={{
          cardTemplateId: cardTemplateId ? cardTemplateId.toString() : 'empty',
          validateAddress
        }}
        onSubmit={this.handleFormSubmit}
        onCancelClick={this.cancelForm}
      />
    )
  }
}

export default injectIntl(withLeftSidebar(EditAddress))
